// extracted by mini-css-extract-plugin
export var container = "about-module--container--2c5b7";
export var heading = "about-module--heading--4f90e";
export var image = "about-module--image--02eeb";
export var imageBox = "about-module--image-box--b522e";
export var text = "about-module--text--2d9ec";
export var textBox = "about-module--text-box--d0b66";